// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  The info-pratiques \`description\` HTML is authored with presentation
  hints baked in: <img width="1024" height="408" style="max-width:320px">.
  Those HTML width/height attributes pin the rendered box to a fixed size
  (squashing the aspect ratio), and the inline max-width only clamps the
  width — leaving the height untouched so the image stretches.

  Reset the HTML hints to \`auto\` so the intrinsic ratio is honoured, then
  cap both dimensions. height/width:auto must come AFTER the UA rules that
  map the width/height attributes, so they need the same specificity but
  later source order — this stylesheet loads after the UA stylesheet.
  The inline \`max-width:320px\` beats our .description img max-width, so we
  override it with !important to let the image use the full container width
  on narrow viewports (and still respect max-height below).
*/
.H1__EUYGaHN2sNU9veZn img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
  max-width: 100% !important;
  max-height: 60vh;
  object-fit: contain;
  border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./web/static/pages/infos-pratiques.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;CAcC;AACD;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/*\n  The info-pratiques `description` HTML is authored with presentation\n  hints baked in: <img width=\"1024\" height=\"408\" style=\"max-width:320px\">.\n  Those HTML width/height attributes pin the rendered box to a fixed size\n  (squashing the aspect ratio), and the inline max-width only clamps the\n  width — leaving the height untouched so the image stretches.\n\n  Reset the HTML hints to `auto` so the intrinsic ratio is honoured, then\n  cap both dimensions. height/width:auto must come AFTER the UA rules that\n  map the width/height attributes, so they need the same specificity but\n  later source order — this stylesheet loads after the UA stylesheet.\n  The inline `max-width:320px` beats our .description img max-width, so we\n  override it with !important to let the image use the full container width\n  on narrow viewports (and still respect max-height below).\n*/\n.description img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: auto;\n  height: auto;\n  max-width: 100% !important;\n  max-height: 60vh;\n  object-fit: contain;\n  border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `H1__EUYGaHN2sNU9veZn`
};
export default ___CSS_LOADER_EXPORT___;
